<template>
  <b-container fluid class="p-0 kub-config-progress pb-2 mt-0">
    <b-row>
      <b-col class="p-0">
        <div class="pt-2 d-flex justify-content-between">
          <span>
            <b-row @click="formComplete ? changeStepForm() : ''" :style="formComplete ? 'cursor:pointer;' : 'cursor:not-allowed'">
              <b-col class="d-flex justify-content-center">
                <div class="kub-step kub-step-current" v-if="!formComplete"></div>
                <div class="kub-step-done d-flex justify-content-center align-items-center" v-else>
                  <b-icon icon="check" scale="1.5"></b-icon>
                </div>
              </b-col>
              <div class="w-100"></div>
              <b-col class="d-flex justify-content-center kub-step-title-done">
                <span v-if="sm" class="kub-config-progress-title">{{steps.form.titleLong}}</span>
                <span v-else class="kub-config-progress-title">{{steps.form.titleShort}}</span>
              </b-col>
            </b-row>
          </span>
          <span class="kub-divider" :class="{'kub-divider-done': formComplete}"></span>
          <span>
            <b-row @click="materialComplete ? changeStepMaterial() : ''" :style="materialComplete ? 'cursor:pointer;' : 'cursor:not-allowed'">
              <b-col class="d-flex justify-content-center">
                <div class="kub-step" :class="{'kub-step-current': formComplete}" v-if="!materialComplete"></div>
                <div class="kub-step-done d-flex justify-content-center align-items-center" v-else>
                  <b-icon icon="check" scale="1.5"></b-icon>
                </div>
              </b-col>
              <div class="w-100"></div>
              <b-col class="d-flex justify-content-center" :class="{'kub-step-title-done': formComplete}">
                <span v-if="sm" class="kub-config-progress-title">{{steps.material.titleLong}}</span>
                <span v-else class="kub-config-progress-title">{{steps.material.titleShort}}</span>
              </b-col>
            </b-row>
          </span>
          <span class="kub-divider" :class="{'kub-divider-done': materialComplete}"></span>
          <span>
            <b-row @click="randComplete ? changeStepRand() : ''" :style="randComplete ? 'cursor:pointer;' : 'cursor:not-allowed'">
              <b-col class="d-flex justify-content-center">
                <div class="kub-step" :class="{'kub-step-current': materialComplete}" v-if="!randComplete"></div>
                <div class="kub-step-done d-flex justify-content-center align-items-center" v-else>
                  <b-icon icon="check" scale="1.5"></b-icon>
                </div>
              </b-col>
              <div class="w-100"></div>
              <b-col class="d-flex justify-content-center" :class="{'kub-step-title-done': materialComplete}">
                <span v-if="sm" class="kub-config-progress-title">{{steps.rand.titleLong}}</span>
                <span v-else class="kub-config-progress-title">{{steps.rand.titleShort}}</span>
              </b-col>
            </b-row>
          </span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Data from '../../../data/main/config/configProgress'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      steps: Data.steps
    }
  },
  methods: {
    ...mapActions([
      'changeStatusForm',
      'changeStatusMaterial',
      'changeStatusRand'
    ]),
    changeStepForm () {
      this.changeStatusForm()
      if (this.materialComplete) {
        this.changeStatusMaterial()
      }
      if (this.randComplete) {
        this.changeStatusRand()
      }
      this.$root.$emit('bv::toggle::collapse', 'kub-form')
      if (!this.lg) {
        setTimeout(() => {
          document.getElementById('kub-heading-setup').scrollIntoView()
        }, 200)
      }
    },
    changeStepMaterial () {
      this.changeStatusMaterial()
      if (this.randComplete) {
        this.changeStatusRand()
      }
      this.$root.$emit('bv::toggle::collapse', 'kub-material')
      if (!this.lg) {
        setTimeout(() => {
          document.getElementById('kub-heading-setup').scrollIntoView()
        }, 200)
      }
    },
    changeStepRand () {
      this.changeStatusRand()
      this.$root.$emit('bv::toggle::collapse', 'kub-rand')
      if (!this.lg) {
        setTimeout(() => {
          document.getElementById('kub-heading-setup').scrollIntoView()
        }, 200)
      }
    }
  },
  computed: {
    ...mapGetters([
      'width',
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      'formComplete',
      'materialComplete',
      'randComplete'
    ])
  }
}
</script>

<style scoped>
.kub-config-progress {
  color:#777877;
  background-color: #fff;
  margin-bottom: 1rem;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.kub-divider {
  flex-grow: 1;
  border-bottom: 2px solid #ddd;
  margin-bottom: 37px;
  margin-left: -85px;
  margin-right: -85px;
}

.kub-divider-done {
  border-bottom: 2px solid #002b36;
}

.kub-step {
  background-color: #ddd;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 1px solid #ddd;
}

.kub-step-current {
  background-color: #002b36;
  border: 1px solid #002b36;
}

.kub-step-done {
  background-color: #002b36;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  color: #fff;
}

.kub-step-title-done {
  color: #002b36;
}

.kub-config-progress-title {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

@media (max-width: 575px) {
  .kub-config-progress {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .kub-divider {
    margin-left: -50px;
    margin-right: -50px
  }
}
</style>
